import UserAppContext from '../../hook/UserAppContext'
import Empty from '../empty/Empty'
import './video.css'

const Video = ({isVideo}) => {

      if(!isVideo) return

      const {user} = UserAppContext()
      const {videos} = user.user 

      if(videos.data){
            return (
                  <Empty text={"Oops! Not Found"}/>
            )
      }

      const url = `https://www.youtube.com/embed/${videos[0].id_video}`
      
      return (
            <div className={isVideo ? "page_content show" : "page_content"}>
                  <div className="content_video">
                        <h2>{videos[0].title}</h2>
                        <div className="video_box">
                              <iframe width="100%" height="100%" src={url} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
                        </div>
                  </div>
            </div>
      )
}

export default Video
